import { Link, useNavigate } from "react-router-dom";
import { Bell, ChevronDown, Wallet, Plus, Coins } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { money, initials } from "@/lib/format";

export const BalancePill = () => {
  const { wallet } = useAuth();
  return (
    <div data-testid="header-balance" className="hidden items-center overflow-hidden rounded-lg border border-cr-line bg-cr-surface md:flex">
      <Link to="/arcade" data-testid="header-coins" className="flex items-center gap-1.5 border-r border-cr-line px-3 py-2 hover:text-cr-gold">
        <Coins className="h-5 w-5 text-cr-gold" />
        <span data-testid="header-coins-amount" className="font-display text-sm font-bold">{(wallet?.coins || 0).toLocaleString("en-IN")}</span>
      </Link>
      <div className="flex items-center gap-2 px-3 py-2">
        <Wallet className="h-5 w-5 text-cr-gold" />
        <span data-testid="header-balance-amount" className="font-display text-sm font-bold">{money(wallet?.balance)}</span>
      </div>
      <Link to="/account/deposit" data-testid="header-deposit-btn" className="btn-gold rounded-none px-4 py-2 text-sm normal-case">
        <Plus className="h-4 w-4" />Deposit
      </Link>
    </div>
  );
};

export default function UserMenu() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const out = async () => { await logout(); nav("/login"); };
  return (
    <div className="flex items-center gap-3">
      <BalancePill />
      <Link to="/account/notifications" data-testid="header-notifications-btn" aria-label="Notifications" className="relative rounded-full p-2 text-cr-ink/90 hover:text-cr-gold">
        <Bell className="h-5 w-5" />
      </Link>
      <DropdownMenu>
        <DropdownMenuTrigger data-testid="user-menu-trigger" className="flex items-center gap-1.5 outline-none">
          <span className="grid h-10 w-10 place-items-center rounded-full border-2 border-cr-gold font-display text-sm font-bold text-cr-gold">{initials(user?.full_name)}</span>
          <ChevronDown className="h-4 w-4 text-cr-muted" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-52 border-cr-line bg-cr-elevated text-cr-ink">
          <div className="px-2 py-1.5 text-xs text-cr-muted">{user?.email}</div>
          <DropdownMenuSeparator />
          <DropdownMenuItem data-testid="menu-overview" onClick={() => nav("/account")}>Dashboard</DropdownMenuItem>
          <DropdownMenuItem data-testid="menu-profile" onClick={() => nav("/account/profile")}>My Profile</DropdownMenuItem>
          <DropdownMenuItem data-testid="menu-wallet" onClick={() => nav("/account/wallet")}>Wallet</DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem data-testid="menu-logout" onClick={out} className="text-cr-danger">Logout</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
